import { c as _c } from "react/compiler-runtime";
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGeneratePdfMutationRequest, FilesControllerGeneratePdfMutationResponse, FilesControllerGeneratePdfPathParams, FilesControllerGeneratePdfHeaderParams, FilesControllerGeneratePdf400, FilesControllerGeneratePdf401, FilesControllerGeneratePdf403, FilesControllerGeneratePdf404 } from "../../models/filesController/FilesControllerGeneratePdf";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { filesControllerGeneratePdf } from "../../clients/filesService/filesControllerGeneratePdf";
import { mutationOptions, useMutation } from "@tanstack/react-query";
export const filesControllerGeneratePdfMutationKey = () => [{
  url: '/api/v1/files/:id/pdf'
}] as const;
export type FilesControllerGeneratePdfMutationKey = ReturnType<typeof filesControllerGeneratePdfMutationKey>;
export function filesControllerGeneratePdfMutationOptions<TContext = unknown>(config: Partial<RequestConfig<FilesControllerGeneratePdfMutationRequest>> & {
  client?: typeof fetch;
} = {}) {
  const mutationKey = filesControllerGeneratePdfMutationKey();
  return mutationOptions<FilesControllerGeneratePdfMutationResponse, ResponseErrorConfig<FilesControllerGeneratePdf400 | FilesControllerGeneratePdf401 | FilesControllerGeneratePdf403 | FilesControllerGeneratePdf404>, {
    id: FilesControllerGeneratePdfPathParams["id"];
    headers: FilesControllerGeneratePdfHeaderParams;
    data?: FilesControllerGeneratePdfMutationRequest;
  }, TContext>({
    mutationKey,
    mutationFn: async ({
      id,
      headers,
      data
    }) => {
      return filesControllerGeneratePdf(id, headers, data, config);
    }
  });
}

/**
 * @description Generates a PDF from the specified file using Nutrient Document Engine. Supports generating a PDF with an HTML based cover page and custom settings. Returns the generated PDF as application/pdf.
 * @summary Generate a PDF from a file
 * {@link /api/v1/files/:id/pdf}
 */
export function useFilesControllerGeneratePdf(t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = options ?? {};
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutation: t3,
    client: t4
  } = t2;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const mutation = t5;
  let t6;
  if ($[6] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const config = t6;
  let mutationOptions;
  let queryClient;
  if ($[8] !== mutation) {
    ({
      client: queryClient,
      ...mutationOptions
    } = mutation);
    $[8] = mutation;
    $[9] = mutationOptions;
    $[10] = queryClient;
  } else {
    mutationOptions = $[9];
    queryClient = $[10];
  }
  let t7;
  if ($[11] !== mutationOptions.mutationKey) {
    t7 = mutationOptions.mutationKey ?? filesControllerGeneratePdfMutationKey();
    $[11] = mutationOptions.mutationKey;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mutationKey = t7;
  let t8;
  if ($[13] !== config) {
    t8 = filesControllerGeneratePdfMutationOptions(config);
    $[13] = config;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const baseOptions = t8 as UseMutationOptions<FilesControllerGeneratePdfMutationResponse, ResponseErrorConfig<FilesControllerGeneratePdf400 | FilesControllerGeneratePdf401 | FilesControllerGeneratePdf403 | FilesControllerGeneratePdf404>, {
    id: FilesControllerGeneratePdfPathParams["id"];
    headers: FilesControllerGeneratePdfHeaderParams;
    data?: FilesControllerGeneratePdfMutationRequest;
  }, TContext>;
  let t9;
  if ($[15] !== baseOptions || $[16] !== mutationKey || $[17] !== mutationOptions) {
    t9 = {
      ...baseOptions,
      mutationKey,
      ...mutationOptions
    };
    $[15] = baseOptions;
    $[16] = mutationKey;
    $[17] = mutationOptions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return useMutation(t9, queryClient) as UseMutationResult<FilesControllerGeneratePdfMutationResponse, ResponseErrorConfig<FilesControllerGeneratePdf400 | FilesControllerGeneratePdf401 | FilesControllerGeneratePdf403 | FilesControllerGeneratePdf404>, {
    id: FilesControllerGeneratePdfPathParams["id"];
    headers: FilesControllerGeneratePdfHeaderParams;
    data?: FilesControllerGeneratePdfMutationRequest;
  }, TContext>;
}